import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ReportsAbstractService } from './reports-abstract.service';
import {
  CustomerJourney,
  CustomerJourneyDetailResponse,
  CustomerJourneyOptionsResponse,
  CustomerJourneyQuery,
} from '../reports/models/reports';

@Injectable()
export class CustomerJourneyReportService extends ReportsAbstractService {
  public reportRoute: string = 'retention_report';
  public journey$: Subject<CustomerJourney> = new Subject<CustomerJourney>();

  constructor(protected http: HttpClient) {
    super(http);
    this.route = this.reportRoute;
  }

  // The Details table pages through journey_detail; every page also carries the journey header.
  getFilteredReport(params: CustomerJourneyQuery): Observable<CustomerJourneyDetailResponse> {
    return this.http.post<CustomerJourneyDetailResponse>(this.route + '/journey_detail/', params).pipe(
      tap((data: CustomerJourneyDetailResponse) => {
        this.journey$.next(data && data.journey ? data.journey : null);
      })
    );
  }

  getJourneyOptions(): Observable<CustomerJourneyOptionsResponse> {
    return this.http.get<CustomerJourneyOptionsResponse>(this.route + '/journey_options/');
  }

  getDownloadReportData(params: CustomerJourneyQuery): Observable<{ download_url: string }> {
    return this.http.post<{ download_url: string }>(this.route + '/journey_download/', params);
  }
}
